
import { ICompany } from "@/sg-hpr";
import _uniq from "lodash/uniq";
import { IHavainnotFormSchema } from "../interfaces/IFormSchema";
import IObservation from "../interfaces/IObservation";
import IPerson from "../interfaces/IPerson";
import { forEachSchemaProperty } from "@sg-schema-form/index";

import _selectn from "selectn";
import _format from "date-fns/format";

const toValues = (obj: any): string => {
    if (obj instanceof Object) {
        return Object.values(obj).map(toValues).join(" ")
    }
    const type = typeof obj
    if (type === "boolean") return "";
    if (type === "undefined") return "";
    return String(obj)
};


export const observationToSearchableText = (
    formData: IObservation["formData"],
    formSchema: IHavainnotFormSchema,
    persons: Array<IPerson>,
    companyList: Array<ICompany>
): string => {
    let parts: Array<string> = [];

    // add person names
    parts = parts.concat(persons.map((person) => person.name).join(" "));


    /**
     *     console.log("observationToSearchableText", { formData, formSchema })
        forEachSchemaProperty(formSchema.schema.properties, formSchema.uiSchema, (path, prop, uiProp) => {
    
            const value = _selectn(path, formData);
    
            const widget = uiProp["ui:widget"] as string;
    
            if (widget) {
                if (["mapLocation", "areaSelect"].includes(widget)) {
                    return
                }
            }
            parts = parts.concat(toValues(value));
    
        })
    
     */

    // add company names
    //  const relatedCompanies = _uniq(persons.map((p) => p.company));
    // parts = parts.concat(relatedCompanies.map((companyId) => companyList.find((c) => c.id === companyId)?.name).join(" "));

    // add formData values
    parts = parts.concat(toValues(formData));

    return parts.join(" ")
}
